import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from './Navigation.module.css';

const Logo = () => {
    return (
        <NavLink to='/'>
            <img
                src='/Asset/dealygo.png'
                alt='DealyGo'
                className={styles.logo}
            />
        </NavLink>
    );
};

export default Logo;